import { LeagueService } from './../../leagues/league.service';
import { League } from '../../_shared/models/league.model';
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import {
  AlertController,
  IonRouterOutlet,
  IonSegment,
  ModalController,
  NavController,
  PopoverController,
} from '@ionic/angular';
import { finalize, takeUntil } from 'rxjs/operators';
import { TeamService } from '../../_core/services/team.service';
import { SelectPlayersPage } from '../../_shared/components/select-players/select-players.page';
import { Participant, Team } from '../../_shared/models/team.model';
import { ToastService } from '../../_core/services/toast.service';
import { Title } from '@angular/platform-browser';
import { TeamPopoverComponent } from './team-popover/team-popover.component';
import { SelectUserComponent } from '../../_shared/components/select-user/select-user.component';
import { Tie } from '../../_shared/models/tie.model';
import { TranslateService } from '@ngx-translate/core';
import { CreateTeamComponent } from '../create-team/create-team.component';
import { TeamHelperService } from '../team-helper.service';
import { Subject } from 'rxjs';
import { END_POINT, ITA_URL } from '../../../environments/environment';
import { TeamDetailsService } from './team-details.service';
import { ItaTeamGetterComponent } from '../create-team/ita-team-getter/ita-team-getter.component';
import { SeasonSelectorComponent } from '../../_shared/components/season-selector/season-selector.component';
import { User } from '../../_shared/models/user.model';
import { AuthService } from '../../auth/auth.service';
import { SelectCoachesPage } from '../../_shared/components/select-coaches/select-coaches.page';
import { filter } from 'rxjs/operators';
import { TeamJoinDialogComponent } from './team-join-dialog/team-join-dialog.component';
import { toastController } from '@ionic/core';
import { Season } from '../../_shared/models/season.model';
import { SeasonSelectorService } from '../../_shared/components/season-selector/season-selector.service';
import { ParticipantsListComponent } from './team-participants/join/participants-list.component';
import { ConfirmEmailComponent } from './confirm-email/confirm-email.component';
import { Capacitor } from '@capacitor/core';
import { AddOrInvitePlayerModal } from './share-team-sheet/add-or-invite-modal.component';

@Component({
  standalone: false,
  selector: 'app-team-details',
  templateUrl: './team-details.component.html',
  styleUrls: ['./team-details.component.scss'],
})
export class TeamDetailsComponent implements OnInit, OnDestroy {
  public authService = inject(AuthService);

  @ViewChild('seasonSelector') SeasonSelectorComponent: SeasonSelectorComponent;
  segmentValue: string = 'schedule';   // default segment
  innerSegmentValue: string; // default inner segment

  // called when toolbar inner segment changes
  teamId: string;
  team: Team;
  ties: Tie[] = [];

  isLoading = false;
  isPlayerLoading = true;
  isOwner: boolean = false;
  players: any[] = [];

  private readonly destroy$: Subject<void> = new Subject();
  isLogoUpdated: boolean;
  imgSource: string;
  isAbbreviationShow: boolean;
  isAuthenticationRequired: Boolean;
  canFollow: boolean;

  private destroyed$: Subject<void> = new Subject();
  isSubmittingFollowingRequest: boolean;
  showFollowedTeams: boolean;
  isSubmittingRemoveAdminRequest: boolean;
  baseUrl: string;
  leagueId: any;
  league: League;
  isOfficial: boolean;
  ITAlogo: string;
  enableAddPlayerBtn: boolean = false;
  isCollapsed = false;
  followers: any[] = [];
  authUser: User;
  isUserTeamPlayer: boolean;
  showIsPlayer: boolean = true;
  private staffJoinState = new Subject<any>();
  public staffState = this.staffJoinState.asObservable();
  participants: Participant[] = [];

  constructor(
    private title: Title,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private modalController: ModalController,
    private popoverController: PopoverController,
    private teamService: TeamService,
    private teamDetailsService: TeamDetailsService,
    private toast: ToastService,
    private routerOutlet: IonRouterOutlet,
    private navCtrl: NavController,
    private alertController: AlertController,
    private translateService: TranslateService,
    public ths: TeamHelperService,
    private seasonSelectorService: SeasonSelectorService,
  ) { }

  collapseStart = 50;     // when shrinking should begin
  collapseEnd = 150;      // when fully shrunk
  collapseThreshold = 150;
  hysteresis = 60;
  collapseProgress = 0;
  selectedSeason: Season;

  toolbarSegments: { value: string, label: string, visible: boolean }[] = [];
  innerToolbarSegments: { value: string, label: string, visible: boolean }[] = [];

  private buildToolbarSegments() {
    this.toolbarSegments = [
      // { value: 'details', label: 'Details', visible: true },
      { value: 'schedule', label: this.translateService.instant('Schedule'), visible: true },
      { value: 'players', label: this.translateService.instant('Team'), visible: true },
      { value: 'lineup', label: this.translateService.instant('LineUp'), visible: this.isOwner },
    ];
  }

  private buildInnerToolbarSegments() {
    this.innerToolbarSegments = [
      { label: this.translateService.instant('Players'), value: 'players', visible: true },
      { label: this.translateService.instant('Staff'), value: 'staff', visible: true },
      { label: this.translateService.instant('Fans'), value: 'fans', visible: true }
    ];
  }



  onScroll(event: CustomEvent) {
    const scrollTop = event.detail.scrollTop;

    // 1️⃣ Smooth progress (0–1)
    let progress =
      (scrollTop - this.collapseStart) / (this.collapseEnd - this.collapseStart);

    this.collapseProgress = Math.min(Math.max(progress, 0), 1);

    // 🔥 Update CSS variable dynamically
    document.documentElement.style.setProperty(
      "--collapse-progress",
      this.collapseProgress.toString()
    );

    // 2️⃣ Boolean toggle with hysteresis (if you still need instant toggle)
    if (!this.isCollapsed && scrollTop > this.collapseThreshold + this.hysteresis) {
      this.isCollapsed = true;
    } else if (this.isCollapsed && scrollTop < this.collapseThreshold - this.hysteresis) {
      this.isCollapsed = false;
    }
  }



  onSegmentChange(value: string) {
    this.segmentValue = value;
    this.innerSegmentValue = 'players'
    this.isPlayerLoading = true;
    this.router.navigate([this.baseUrl, value]);
  }

  onInnerSegmentChange(value: string) {
    this.innerSegmentValue = value;
    this.isPlayerLoading = true;
    if (value === 'staff') {
      this.router.navigate([this.baseUrl, value], {
        state: { team: this.team }
      });
    } else {
      this.router.navigate([this.baseUrl, value]);
    }
  }

  isPlayer(res: Participant[]) {
    this.showIsPlayer = res?.some(
      c => c?.person?.claimedBy?._id === this.authUser?._id && (c?.person?.claim_status === 'pending' || c?.person?.claim_status === 'verified')
    ) || false;
    this.isPlayerLoading = false;
  }

  async ngOnInit() {
    this.authUser = await this.authService.getAuthUser();
    const topModal = await this.modalController.getTop();
    if (topModal) {
      await this.modalController.dismiss();
    }
    this.title.setTitle('iOnCourt | Team Details');
    this.teamId = this.activatedRoute.snapshot.params.id;
    this.leagueId = this.activatedRoute.snapshot.params.leagueId;
    await this.getTeamInfo();
    this.fetchParticipants();
    this.buildToolbarSegments();
    this.buildInnerToolbarSegments();
    this.subscriptions();
    this.baseUrl = this.router.url;
    this.selectedSeason = this.seasonSelectorService.season;
    localStorage.removeItem('returnTo');

    // Set default value for the segment based on URL that was provided
    const urlSplit = this.router.url.split('/');
    const teamInnerSegments = ['staff', 'players', 'fans'];

    if (urlSplit.length === 4) {
      if (teamInnerSegments.includes(urlSplit[3])) {
        this.innerSegmentValue = urlSplit[3];
        this.segmentValue = 'players';
      } else {
        this.segmentValue = urlSplit[3];
      }
      this.baseUrl = `${urlSplit[0]}/${urlSplit[1]}/${urlSplit[2]}`;
    } else if (urlSplit.length === 6) {
      if (teamInnerSegments.includes(urlSplit[5])) {
        this.innerSegmentValue = urlSplit[5];
        this.segmentValue = 'players';
      } else {
        this.segmentValue = urlSplit[5];
      }
      this.baseUrl = `${urlSplit[1]}/${urlSplit[2]}/${urlSplit[3]}/${urlSplit[4]}`;
    } else {
      // If URL doesn't have spectific segment navigate to the player's page
      this.segmentValue = 'schedule';
      this.router.navigate([this.baseUrl, 'schedule']);
    }

    // this.segmentValue.subscribe((event) => {
    //   this.router.navigate([this.baseUrl, event.detail.value]);
    // });

    this.teamDetailsService.subscribePublishParticipants()
      .pipe(
        takeUntil(this.destroy$),
      ).subscribe(
        (res) => {
          this.isPlayer(res);
        }
      );
    this.subscriptions();

  }

  async openInviteSheet() {
    let baseUrl: string;

    if (Capacitor.isNativePlatform()) {
      baseUrl = END_POINT + '/';
    } else {
      baseUrl = window.location.origin + '/';
    }

    const joinUrl = `${baseUrl}join/${this.team._id}`;
    const modal = await this.modalController.create({
      component: AddOrInvitePlayerModal,
      cssClass: 'bottom-sheet',
      componentProps: {
        inviteLink: joinUrl,
        view: 'sheet'
      },
      breakpoints: [0, 0, 3, 0.35, 0.5, 0.7, 1],
      initialBreakpoint: 0.25
    });
    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      if (data.addMyPlayer) {
        this.addPlayer();
      }
    }
  }

  // onInnerSegmentChange(event: CustomEvent) {
  //   this.router.navigate([this.baseUrl, event.detail.value]);
  // }

  async subscriptions() {
    this.teamDetailsService.subscribeUpdateStaff().pipe
      (takeUntil(this.destroy$))
      .subscribe((update) => {
        if (update) {
          this.getTeamInfo();
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.teamDetailsService.publishOrganisationId(null);
  }

  async getTeamInfo() {
    this.isLoading = true;
    this.team = await this.teamDetailsService.info(this.teamId);
    this.teamDetailsService.publishOrganisationId(this.team?.organisations?.[0]?._id ?? null)
    this.isOwner = this.teamDetailsService.isOwner(this.team.owners);
    this.isOfficial = await this.teamDetailsService.isOfficial(
      this.team.officials
    );
    this.canFollow = !this.team.viewers.some(
      (viewer) => this.authService.authUserSignal()?._id === viewer
    );

    if (this.team && this.team?.organisations && (this.team.organisations[0]?.organisationAbbreviation === 'ITA')) {
      this.ITAlogo = `${ITA_URL}/${this.team?.teamId?.toUpperCase()}/Logo`;
    }
    this.isUserTeamPlayer = this.team.participants?.some(
      (p) => p?.person?._id == this?.authService?.authUserSignal()?._id
    ) ?? false;
    this.enableAddPlayer();
  }

  fetchParticipants() {
    this.teamDetailsService.getParticiapnts(this.teamId, this.selectedSeason?._id, 'player')
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => this.isPlayerLoading = false)
      )
      .subscribe({
        next: (res) => {
          this.participants = res?.data?.participants;
          this.isPlayer(res.data?.participants);
        }
      });
  }

  async addPlayer() {
    if (
      this.team.organisations?.some(
        (o) => o?.organisationAbbreviation === 'ITA'
      )
    ) {
      const alert = await this.alertController.create({
        header: this.translateService.instant('Add player'),
        message:
          this.translateService.instant('To update roster go to ITA admin portal. When you are done come back to this page and update team to synchronize your players.'),
        buttons: ['Ok'],
      });

      await alert.present();
      return;
    }

    const popover = await this.modalController.create({
      component: SelectPlayersPage,
      presentingElement: this.routerOutlet.nativeEl,
    });

    await popover.present();
    const { data } = await popover.onDidDismiss();

    if (data) {
      const participantObj = {
        person: data[0]._id,
        roles: ['player'],
      };
      this.teamService
        .addPlayer(this.team._id, participantObj)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res) => {
            this.team = res.data;
            this.teamDetailsService.publishTeamUpdate(this.team);
            this.toast.presentToast(res.message);
          },
          error: (err) => {
            const message = err?.message || err?.error?.message || 'An error occurred';
            this.toast.presentDangerToast(message);
          },
        });
    }
  }


  async addCoach() {
    const popover = await this.modalController.create({
      component: SelectCoachesPage,
      presentingElement: this.routerOutlet.nativeEl,
    });

    await popover.present();
    const { data } = await popover.onDidDismiss();

    if (data) {
      this.teamService
        .addCoachToTeam(this.team._id, data._id)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res) => {
            this.team = res.data;
            this.teamDetailsService.publishTeamUpdate(this.team);
            this.toast.presentToast(res.message);
          },
          error: (err) => {
            const message = err?.message || 'An error occurred';
            this.toast.presentDangerToast(message);
          }
        });
    }
  }

  async showTeamPopover(ev: any) {
    const popover = await this.popoverController.create({
      component: TeamPopoverComponent,
      componentProps: {
        canFollow: !this.canFollow,
        isOwner: this.isOwner
      },
      event: ev,
      translucent: false,
    });

    await popover.present();

    const { data } = await popover.onDidDismiss();

    if (data === 'owner') this.addOwner();
    else if (data === 'update') this.updateTeam();
    else if (data === 'delete') this.deleteTeam();
    else if (data === 'leave') this.changeFollow();
  }

  async updateTeam() {
    const modal = await this.modalController.create({
      component: CreateTeamComponent,
      componentProps: {
        isEdit: true,
        team: this.team,
        seasonId: this.SeasonSelectorComponent?.selectedSeason.seasonId,
        ITAlogo: this.ITAlogo,
      },
    });

    await modal.present();
    const { data } = await modal.onDidDismiss<{ _doc: Omit<Team, 'profile_image'> } & {
      profile_image?: {
        thumbnail: string;
        original: string;
        medium: string;
      }
    }>();

    if (data) {
      this.team = { ...data._doc, profile_image: data.profile_image?.thumbnail };
      this.teamDetailsService.publishTeamUpdate(this.team);
      this.getTeamInfo();
      const updatedTeams = this.teamService.teams.map(
        team => team._id === this.team._id ? this.team : team
      );

      this.teamService.publishTeamsUpdate(
        updatedTeams
      );
    }
  }

  private async deleteTeam() {
    this.translateService
      .get([
        'Delete team',
        'All matches for this team will be deleted. This action cannot be undone. Are you sure that you want to delete this team?',
        'Yes, delete',
        'No, keep it',
      ])
      .subscribe(async (translations) => {
        const alert = await this.alertController.create({
          header: translations['Delete team'],
          message:
            translations[
            'All matches for this team will be deleted. This action cannot be undone. Are you sure that you want to delete this team?'
            ],
          buttons: [
            {
              text: translations['Yes, delete'],
              role: 'destructive',
              handler: () => this.handleDeleteTeam(),
            },
            {
              text: translations['No, keep it'],
            },
          ],
        });

        await alert.present();
      });
  }

  private handleDeleteTeam() {
    this.teamService
      .deleteTeam(this.teamId)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => { })
      )
      .subscribe({
        next: () => {
          this.toast.presentToast('Team is deleted successfully');
          this.teamDetailsService.publishDeleteTeam(this.teamId);
          this.navCtrl.navigateBack('/my-teams');
        },
      });
  }

  async addOwner() {
    const modal = await this.modalController.create({
      component: SelectUserComponent,
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();

    if (data) {
      this.teamService
        .addOwner(this.team._id, data.country_code + data.phone, data.email)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res) => {
            // Data comes back populated
            const owners = res.data;
            this.team.owners = owners.map((owner) => owner._id);
            this.toast.presentToast(res.message);
            this.teamDetailsService.publishAddOwner(owners);
          },
        });
    }
  }

  async showItaLoginPopover() {
    const modal = await this.modalController.create({
      component: ItaTeamGetterComponent,
      componentProps: {
        groupId: this.team.teamId,
      },
      presentingElement: await this.modalController.getTop(),
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();

    if (data) {
      this.teamDetailsService
        .authenticateOwner(this.team._id)
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => {
            // this.isLoading = false;
          })
        )
        .subscribe(async (res) => {
          const team = res.data;
          this.team.authentication = team.authentication;
          this.team.owners = team.owners;
          this.isOwner = this.teamDetailsService.isOwner(this.team.owners);
          this.isAuthenticationRequired = this.setIsAuthRequired();
          this.toast.presentToast(res.message);
          this.teamDetailsService.publishTeamUpdate(this.team);
        });
    } else {
      const alert = await this.alertController.create({
        header: this.translateService.instant('Team authorisation failed'),
        message:
          this.translateService.instant('You must be a staff member of this team to activate new season. Your credentials are incorrect or you are not a staff member of this team on ITA workspace. If you need help reach out via support@ioncourt.com.'),
        buttons: [
          {
            text: this.translateService.instant('Close'),
          },
        ],
      });

      await alert.present();
    }
  }

  setIsAuthRequired(): Boolean {
    return (
      !this.team?.authentication.status &&
      this.team.organisations &&
      this.team.organisations.some(
        (o) => o.organisationAbbreviation === 'ITA'
      ) &&
      this.isOwner
    );
  }

  changeFollow() {
    this.isSubmittingFollowingRequest = true;
    if (this.canFollow) {
      this.teamDetailsService
        .follow(this.teamId)
        .pipe(
          finalize(() => (this.isSubmittingFollowingRequest = false)),
          takeUntil(this.destroyed$)
        )
        .subscribe({
          next: (res) => {
            this.canFollow = false;
            this.team.viewers.push(this.authService.authUserSignal()?._id);
            this.toast.presentToast(res.message);
            this.teamDetailsService.publishUpdateFans(true);
          },
          error: (err) => {
            this.isSubmittingFollowingRequest = false;
            const message = err?.message || err?.error?.message || 'An error occurred';
            this.toast.presentDangerToast(message);
          }
        });
    } else {
      this.teamDetailsService
        .unfollow(this.teamId)
        .pipe(
          finalize(() => (this.isSubmittingFollowingRequest = false)),
          takeUntil(this.destroyed$)
        )
        .subscribe({
          next: (res) => {
            this.canFollow = true;
            this.team.viewers.forEach((viewer, i) => {
              if (viewer === this.authService.authUserSignal()?._id) {
                this.team.viewers.splice(i, 1);
              }
            });
            this.toast.presentToast(res.message);
            this.teamDetailsService.publishUpdateFans(true);
          },
          error: (err) => {
            this.isSubmittingFollowingRequest = false;
            const message = err?.message || err?.error?.message || 'An error occurred';
            this.toast.presentDangerToast(message);
          },
        });
    }
  }

  async displayStaffJoin() {
    const modal = await this.modalController.create({
      component: ConfirmEmailComponent,
      componentProps: {
        displayEmail: `You must be current staff of this school.\n All staff members will receive notification that you joined the team.\n\n You must enter .edu address.`,
        userId: this.authUser._id,
        teamId: this.teamId
      },
      presentingElement: await this.modalController.getTop(),
    });

    modal.onDidDismiss().then((result) => {
      if (result.data) {
        if (result.data?.confirmed) {
          this.staffJoinState.next(result.data);
          this.getTeamInfo();
        }
      }
    });

    await modal.present();
  }

  async onJoinTeam() {
    const popover = await this.modalController.create({
      component: TeamJoinDialogComponent,
      componentProps: {
        canFollow: this.canFollow,
        isOwner: this.isOwner,
        isUserTeamPlayer: this.isUserTeamPlayer || this.showIsPlayer,
      }
    });
    await popover.present();

    const { role } = await popover.onDidDismiss();

    switch (role) {
      case 'player':
        // Add player
        this.displayJoinAsPlayer();
        break;
      case 'parent':
        // Add parent
        break;
      case 'fan':
        if (this.canFollow) {
          this.changeFollow();
        } else {
          this.toast.presentDangerToast('You\'re already a fan of this team');
        }
        break;
      case 'staff':
        this.displayStaffJoin();
      default:
        // Dismissed
        break;
    }
  }

  async joinTeam() {
    await this.teamDetailsService.joinTeam(this.teamId).subscribe((s) => {
      if (s.error) {
        this.toast.presentDangerToast(`Error joining team: ${s.error.message || s.error}`);
        return;
      }
      this.getTeamInfo();
      this.toast.presentToast(`You have joined ${this.team.name}!`);
    });
  }

  async displayJoinAsPlayer() {
    const modal = await this.modalController.create({
      component: ParticipantsListComponent,
      componentProps: {
        displayEmail: `You must be current staff of this school.\n All staff members will receive notification that you joined the team.\n\n You must enter .edu address.`,
        userId: this.authUser._id,
        teamId: this.teamId
      },
      presentingElement: await this.modalController.getTop(),
    });

    modal.onDidDismiss().then((result) => {
      if (result.data) {
        if (result.data?.confirmed) {
          this.staffJoinState.next(result.data);
          this.getTeamInfo();
        }
      }
    });

    await modal.present();
  }

  async removeAdminOwner() {
    const alert = await this.alertController.create({
      header: this.translateService.instant('Leave team'),
      message: this.translateService.instant('Do you want to leave this team?'),
      buttons: [
        {
          text: this.translateService.instant('Yes'),
          handler: () => {
            this.isSubmittingRemoveAdminRequest = true;

            this.teamService
              .removeAdminOwner(this.teamId)
              .pipe(
                finalize(() => (this.isSubmittingRemoveAdminRequest = false)),
                takeUntil(this.destroyed$)
              )
              .subscribe({
                next: (res) => {
                  this.team.owners = res.data;
                  this.toast.presentToast(res.message);
                  this.router.navigate(['/my-teams']);
                },
              });
          },
        },
        {
          text: this.translateService.instant('No'),
        },
      ],
    });

    await alert.present();
  }

  verifyTeam() {
    this.teamDetailsService
      .verifyTeam(this.team._id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((res) => {
        this.toast.presentToast(res.message);
      });
  }


  /*
  * This function enables the add player button based on the allowAddPlayer property.
  * If no organization and I am owner of the, team then return true
  * If organiation is attached with team and allowAddPlayer = true then return true
  * If organization is attached with team and allowAddPlayer = false then return false
  * If the user is not the owner, the button is hide.
  */
  enableAddPlayer() {
    if (!this.isOwner) return;

    const organisations = this.team?.organisations;
    const organisation = this.team?.organisation;

    // If no organisation is attached and user is the owner, allow add player
    if ((!organisations || organisations.length === 0) && !organisation) {
      this.enableAddPlayerBtn = true;
      return;
    }

    // If organisation is attached and allowAddPlayer is true, allow add player
    const allowAdd =
      (organisations?.[0]?.allowAddPlayer ?? true) &&
      (organisation?.allowAddPlayer ?? true);

    this.enableAddPlayerBtn = allowAdd;
  }
}
